module.exports = __webpack_public_path__ + "fonts/Gotham-Light.ccf2d84a.ttf";